var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhite10Inline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 85,
  height: 85,
  viewBox: "0 0 85 85",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 27.3 0 42.4l15.1 15.2V27.3Zm54.8 30.3L85 42.4 69.9 27.3v30.3ZM57.7 15.1 42.5 0 27.4 15.1h30.3ZM27.4 69.8l15.1 15.1 15.2-15.1H27.4Zm-1.3-41.5H59v9.1H26.1v-9.1Zm0 18.8H59v9.5H26.1v-9.5Z",
  fill: "#FFF",
  fillRule: "nonzero"
})));
export default SvgWhite10Inline;